import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  getJsonFileFailure,
  getJsonFileSuccess,
} from "../../actions";
import { JSON_FILE } from "../../Actions/types";
import api from "../../../helper/api";

function* fetchJsonFile(action) {
  try {
    const response = yield api.post("/admin/glb/upload-json", action?.payload?.form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(getJsonFileSuccess({ getData: response?.data }));
      toast.success(response?.data?.message);
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(getJsonFileFailure({ getError: e }));
  }
}

function* jsonFileWatcher() {
  yield takeLatest(JSON_FILE, fetchJsonFile);
}

export default function* jsonFileSaga() {
  yield all([jsonFileWatcher()]);
}
